import { useState, useCallback } from 'react';
import { API_CONFIG, API_ENDPOINTS } from '../config/api';
import { uploadAttachments } from '../utils/attachmentUpload';
import type { ReportRequest, ReportResponse } from '../types/report';

export function useSubmitReport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(async (request: ReportRequest): Promise<ReportResponse['result'] | null> => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('accessToken');
      const userId = localStorage.getItem('userId');
      const res = await fetch(`${API_CONFIG.baseURL}${API_ENDPOINTS.REPORT.SUBMIT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
          ...(userId && { KEY_USER_ID: userId }),
        },
        credentials: 'include',
        body: JSON.stringify({
          reportedId: Number(request.reportedId),
          category: request.category,
          description: request.description,
          cardId: request.cardId ? Number(request.cardId) : null,
        }),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData?.error?.message ?? '신고 접수에 실패했습니다.');
      }

      const data = await res.json();
      const result = data.result;
      const resultId: number | undefined = result?.reportId ?? result?.id;

      // 2단계: 첨부파일 업로드
      if (request.attachments && request.attachments.length > 0 && resultId) {
        try {
          await uploadAttachments('REPORT', resultId, request.attachments);
        } catch (uploadErr) {
          console.warn('첨부파일 업로드 실패:', uploadErr);
          // 본문은 이미 제출되었으므로 계속 진행
        }
      }

      return result;
    } catch (err: any) {
      setError(err.message ?? '신고 접수에 실패했습니다.');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { submit, loading, error };
}
